import { PopoverProps } from '@mui/material';
import { createContext, ReactNode } from 'react';

export interface MenuActions {
  open: () => void;
  close: () => void;
}

export interface MenuProps extends Omit<PopoverProps, 'open' | 'ref'> {
  onOpen?: () => void;
  trigger: ReactNode;
  disabled?: boolean;
}

export const menuContext = createContext<MenuActions | null>(null);
